import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { BreakPointMobile } from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  dialog: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    [BreakPointMobile]: {
      gap: 12,
    },
  },
  title: {
    [BreakPointMobile]: {
      fontSize: "20px !important",
    },
  },
  description: {
    [BreakPointMobile]: {
      fontSize: "14px !important",
    },
  },
}));
